module.exports = __webpack_public_path__ + "img/public/siteImages/defaultPicNew.svg?23c21d44";